import httpClient from '@/common/httpClient'
import { apolloClient } from '@/common/service/apolloClient'
import { sortedProductsQuery, categoryCmsContentQuery } from '@/categories/queries'
import { CATEGORY_SKUS_ENDPOINTS } from '@/categories/const'
import { camelCase } from 'lodash'
import { getCategoryCMSContent } from './types/getCategoryCMSContent'

export const getSortedProductsList = (categoryIds: number, sortOrder: string) => {
  return apolloClient.query({
    query: sortedProductsQuery,
    variables: {
      categoryIds: categoryIds,
      sortOrder: sortOrder
    }
  })
}

export const fetchCategoryProductList = (categoryId: number, offset = 0, limit = 40) => {
  const api = CATEGORY_SKUS_ENDPOINTS + categoryId.toString()
  return httpClient.get(api, {
    params: {
      offset,
      limit
    }
  }).then(res => {
    const data = res.data ?? {}
    if (typeof data.items === 'string') data.items = JSON.parse(data.items)
    data.items = data.items?.map((sku: any) => {
      return Object.keys(sku).reduce((skuData: any, currKey) => {
        const camelKey = camelCase(currKey)
        skuData[camelKey] = sku[currKey]
        return skuData
      }, {})
    })
    return { data }
  })
}

export const getCategoryRelatedCMSContent = (categoryId: string) => {
  return apolloClient.query<getCategoryCMSContent>({
    query: categoryCmsContentQuery,
    variables: {
      id: categoryId
    },
    fetchPolicy: 'no-cache'
  })
}
